function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TokelauFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1119",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1119)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1119",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1119)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.47086 10.5475L1.80669 10.9585L2.06454 10.2686L1.5 9.74628H2.18475L2.47086 9L2.6892 9.74628H3.375L2.88076 10.2686L3.12274 10.9585L2.47086 10.5475Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.47086 7.54754L4.80669 7.95851L5.06454 7.26859L4.5 6.74628H5.18475L5.47086 6L5.6892 6.74628H6.375L5.88076 7.26859L6.12274 7.95851L5.47086 7.54754Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.47086 10.5475L7.80669 10.9585L8.06454 10.2686L7.5 9.74628H8.18475L8.47086 9L8.6892 9.74628H9.375L8.88076 10.2686L9.12274 10.9585L8.47086 10.5475Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.47086 13.5475L4.80669 13.9585L5.06454 13.2686L4.5 12.7463H5.18475L5.47086 12L5.6892 12.7463H6.375L5.88076 13.2686L6.12274 13.9585L5.47086 13.5475Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6315 7.09732C15.5689 8.61019 5.50591 15.4089 5.50591 15.4089H22.2693C22.1018 15.3715 21.9457 15.3404 21.7984 15.3111C20.5678 15.066 19.9604 14.9451 18.6315 12.2978C17.1435 9.33372 18.6315 7.09732 18.6315 7.09732ZM4.96177 16.4738L4.73254 17.0438L4.96177 17.67L22.027 18L22.5 17.1302L22.027 16.5039L4.96177 16.4738Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Tokelau.js.map